import type TranscriptTurnFormData from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/InterviewDetails/TranscriptReviewSection/FormData/TranscriptTurnFormData';
import type TranscriptTurnView from '@UI/Store/Interviews/Views/TranscriptTurnView';
import * as React from 'react';

export type AudioEditContextType = {
	readonly editingTurnId: number | null;
	readonly formData: TranscriptTurnFormData;
	readonly isSubmitting: boolean;
	readonly hasUnsavedEdit: boolean;
	readonly openTurn: (turn: TranscriptTurnView) => void;
	readonly changeText: (value: string) => void;
	readonly submit: () => void;
	readonly cancel: () => void;
	readonly runGuarded: (action: () => void) => void;
};

const AudioEditContext = React.createContext<AudioEditContextType | null>(null);

export default AudioEditContext;
